import React, { FC, useState, useEffect } from "react";
import { ReactSVG } from "react-svg";

import { Row, Col, Button } from "antd";
const GenderInput: React.FC<any> = ({ value = undefined, onChange }) => {
  const [selected, setSelected] = useState<string>();

  useEffect(() => {
    if(value){
      setSelected(value);
    }
  }, [value]);

  return (
    <Row className="mt-4 d-flex d-around">
      <Col>
        <Button
          className={`primary beam-btn ${
            selected === "male" ? "blue-btn" : ""
          }`}
          onClick={() => {
            if(selected !== "male"){
            setSelected("male");
            onChange("male");
            }
            else{
              setSelected(undefined);
              onChange(undefined);
            }
          }}
        >
          <ReactSVG src="/images/male-icon.svg" />
        </Button>
        <h5 className="mt-2">
          <b>Male</b>
        </h5>
      </Col>
      <Col>
        <Button
          className={`primary beam-btn ${
            selected === "female" ? "blue-btn" : ""
          }`}
          onClick={() => {
            if(selected !== "female"){
              setSelected("female");
              onChange("female");
              }
              else{
                setSelected(undefined);
                onChange(undefined);
              }
          }}
        >
          <ReactSVG src="/images/female-icon.svg" />
        </Button>
        <h5 className="mt-2">
          <b>Female</b>
        </h5>
      </Col>
    </Row>
  );
};

export default GenderInput;